export default "__VITE_PUBLIC_ASSET__c49b09c7__"